<div class="position-relative">
  @if (isLoading || isSaving) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md', text: isSaving ? 'Saving...' : '' }"></loader>
  }

  <a href="javascript:void(0);" class="finance-back-link d-inline-block mb-3" (click)="cancel()">
    <i class="fa fa-solid fa-chevron-left me-1"></i>Back to Finance Income
  </a>

  <div class="finance-panel">
    <div class="finance-panel-header">
      <div>
        <h5 class="finance-panel-title">Edit Instalment{{ invoice ? ' — ' + invoice.instalmentTypeName : '' }}</h5>
        <small class="text-muted">
          Row generated automatically from the linked Proposal's payment conditions — only payment details below are editable.
        </small>
      </div>
      @if (invoice) {
        <span [class]="statusClass(invoice.status)">{{ statusLabel(invoice.status) }}</span>
      }
    </div>

    <div class="finance-panel-body">
      @if (invoice) {
        <form [formGroup]="form" class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="fw-bold">Instalment</label>
                  <div class="input-group shadow-sm">
                    <input type="text" class="form-control" disabled
                      [value]="invoice.instalmentTypeName ? invoice.instalmentTypeName + ' (' + invoice.percent + '%)' : ''" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="fw-bold">Amount</label>
                  <div class="input-group shadow-sm">
                    <input type="text" class="form-control" disabled
                      [value]="invoice.amount != null ? (invoice.amount | currency: currency) : ''" />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <input-field
                  label="Due Date"
                  [inputFormControl]="getControl('dueDate')"
                  [type]="'date'"
                  [readonly]="false">
                </input-field>
                <div class="finance-field-hint">
                  Drives the overdue escalation timeline.
                </div>
              </div>
              <div class="col-md-6">
                <input-field
                  label="Paid Date"
                  [inputFormControl]="getControl('paidDate')"
                  [type]="'date'"
                  [readonly]="false">
                </input-field>
              </div>
              <div class="col-md-6">
                <input-field
                  label="Bank Received"
                  placeholder="e.g. Intesa Sanpaolo"
                  [inputFormControl]="getControl('bankReceived')"
                  [type]="'text'"
                  [readonly]="false">
                </input-field>
              </div>

              <div class="col-md-6">
                <input-field
                  label="Reference"
                  placeholder="Invoice no. / internal reference"
                  [inputFormControl]="getControl('reference')"
                  [type]="'text'"
                  [readonly]="false">
                </input-field>
              </div>

              <div class="col-12">
                <textarea-field
                  label="Note"
                  placeholder="Optional annotations"
                  [textareaFormControl]="getControl('note')"
                  [readonly]="false"
                  [height]="80">
                </textarea-field>
              </div>

              <div class="col-12 mt-2">
                <projects-finance-attachment
                  label="Invoice Attachment"
                  accept="application/pdf,.pdf"
                  emptyText="No invoice attached yet"
                  [attachment]="invoice.attachment"
                  [pendingFile]="selectedFile"
                  [validateFile]="validateInvoiceFile"
                  (pendingFileChange)="onPendingFileChange($event)"
                  (download)="openAttachment()">
                </projects-finance-attachment>
              </div>
            </div>
          </div>
        </form>

        <div class="finance-form-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
          <button type="button" class="btn btn-success" [disabled]="isSaving" (click)="save()">Save changes</button>
        </div>
      }
    </div>
  </div>
</div>
